import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import * as React from 'react';
import { useIsMobile } from './useIsMobile.mjs';

function useHover() {
  var isMobile = useIsMobile();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var ref = React.useRef(null);
  React.useEffect(function () {
    if (!isMobile) {
      var node = ref.current;
      var handleMouseEvent = function handleMouseEvent(event) {
        setValue(event.type === "mouseenter");
      };
      if (node) {
        node.addEventListener("mouseenter", handleMouseEvent);
        node.addEventListener("mouseleave", handleMouseEvent);
        return function () {
          node.removeEventListener("mouseenter", handleMouseEvent);
          node.removeEventListener("mouseleave", handleMouseEvent);
        };
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current]);
  return [ref, value];
}

export { useHover };
